import React from 'react';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import CustomTittle from '../../components/Elements/customTittle/customTittle';
import CustomRedText from '../../components/Elements/redText/redText';
import QuestionFAQ from './tittle/tittleFAQ';
import CoursBar from '../../components/pulpit/cours_bar';

import './faq.css';

const FAQ = (props) => {
    const [isExpand, setIsEcpand] = useState({
        ogolne: false,
        where: false,
        who: false,
        kids: false,
    });

    useEffect(() => {
        props.setHeader('/  FAQ');
    }, []);
//     <CoursBar
//     onSelect={(status) =>
//         setChoosenBar({
//             ...choosenBar,
//             regular: status,
//         })
//     }
//     name={'Zajęcia regularne'}
//     tittle={groupHeader}
// ></CoursBar>

    return (
        <>
            <div className="dashboard__content">
                <main>
                    <div className="serviceWrapper">
                        <CustomTittle size={'h4'}>FAQ</CustomTittle>
                        <div className="faqContent">
                            <CoursBar
                                isExpand={isExpand['ogolne']}
                                onSelect={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ ogolne: e },
                                    });
                                }}
                                name={"PYTANIA OGÓLNE"}
                            >
                                
                            </CoursBar>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['where']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ where: e },
                                    });
                                }}
                                isRed={isExpand['where']}
                            >
                                Gdzie odbywają się zajęcia taneczne?
                            </QuestionFAQ>
                            <p className={isExpand.where ? 'answer' : 'dont'}>
                            Zajęcia odbywają się w 13 lokalizacjach Egurrola Dance Studio: w Warszawie (w CH Blue City, na Ochocie, w Śródmieściu, na Tarchominie – w Galerii Północnej, na Bródnie – w Galerii Renova, na Pradze-Południe – w Atrium promenada oraz w Wawrze – w CH Ferio), w Krakowie, we Wrocławiu, w Katowicach, w Łodzi, w Konstancinie-Jeziornie oraz w Grodzisku Mazowieckim. Adresy poszczególnych szkół znajdują się na podstronie <a>„Lokalizacje”</a>.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['who']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ who: e },
                                    });
                                }}
                                isRed={isExpand['who']}
                                
                            >
                                Czy na zajęcia mogą zapisać się osoby, które nigdy wcześniej nie
                                tańczyły?
                            </QuestionFAQ>
                            <p className={isExpand.who ? 'answer' : 'dont'}>
                            Oczywiście! W naszej ofercie dostępne są zajęcia dla osób na różnych poziomach zaawansowania, w tym także dla początkujących.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['howMuch']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ howMuch: e },
                                    });
                                }}
                                isRed={isExpand['howMuch']}
                            >
                                Jaki jest koszt pojedynczych zajęć?
                            </QuestionFAQ>
                            <p className={isExpand.howMuch ? 'answer' : 'dont'}>
                            Koszt pojedynczych zajęć waha się w granicach 60-140 zł. Na cenę ma wpływ długość trwania zajęć oraz ich rodzaj. Należy pamiętać, że korzystniejsze jest wykupienie umowy zajęć, wtedy cena pojedynczej lekcji jest odpowiednio niższa.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['contract']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ contract: e },
                                    });
                                }}
                                isRed={isExpand['contract']}
                            >
                                Jakie są rodzaje umów?
                            </QuestionFAQ>
                            <p className={isExpand.contract ? 'answer' : 'dont'}>
                                Oferujemy umowy roczne (10-miesięczne) oraz semestralne
                                (5-miesięczne).
                            </p>
                        </div>
                         <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['how']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ how: e },
                                    });
                                }}
                                isRed={isExpand['how']}
                            >
                                {' '}
                                W jaki sposób można zapisać się na zajęcia?
                            </QuestionFAQ>
                            <p className={isExpand.how ? 'answer' : 'dont'}>
                            Zapisu na zajęcia można dokonać przez panel klienta (logowanie w prawym górnym rogu ekranu), wybierając jedną z wielu wygodnych form płatności on-line, osobiście w recepcji wybranej szkoły Egurrola Dance Studio, telefonicznie lub mailowo. Przygotowaliśmy szereg rozwiązań, które pomogą w szybkim i sprawnym procesie zakupu wybranego kursu.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['discount']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ discount: e },
                                    });
                                }}
                                isRed={isExpand['discount']}
                            >
                                Czy są jakieś zniżki na zajęcia?
                            </QuestionFAQ>
                            <p className={isExpand.discount ? 'answer' : 'dont'}>
                                Tak, oferujemy zniżkę rodzinną w wysokości 5%. Szczegółowe
                                informacje na temat zasad udzielania zniżek znajdują się w zakładce
                                „Cennik” w danej kategorii.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['onePerson']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ onePerson: e },
                                    });
                                }}
                                isRed={isExpand['onePerson']}
                            >
                                Czy można zapisać się na zajęcia indywidualne?
                            </QuestionFAQ>
                            <p className={isExpand.onePerson ? 'answer' : 'dont'}>
                            Tak. Zajęcia indywidualne to świetne rozwiązanie, w szczególności dla solistów i duetów przygotowujących się do startu w zawodach, dla osób zapracowanych, które nie mają czasu na udział w kursach regularnych oraz dla narzeczonych. Szczegółowe informacje na temat lekcji indywidualnych znajdują się w górnej zakładce „Lekcje indywidualne” w danej kategorii.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['multiSPort']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ multiSPort: e },
                                    });
                                }}
                                isRed={isExpand['multiSPort']}
                            >
                                Czy honorujecie karty MultiSport?
                            </QuestionFAQ>
                            <p className={isExpand.multiSPort ? 'answer' : 'dont'}>Nie.</p>
                        </div>
                        
                        
                        
                        
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['eq']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ eq: e },
                                    });
                                }}
                                isRed={isExpand['eq']}
                            >
                                Co należy zabrać ze sobą na zajęcia?
                            </QuestionFAQ>
                            <p className={isExpand.eq ? 'answer' : 'dont'}>
                                 Na zajęciach należy mieć ze sobą wodę do picia.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['when']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ when: e },
                                    });
                                }}
                                isRed={isExpand['when']}
                            >
                                Czy jest możliwość zapisania się na zajęcia w trakcie semestru, czy
                                tylko na początku?
                            </QuestionFAQ>
                            <p className={isExpand.when ? 'answer' : 'dont'}>
                                Na zajęcia można zapisać się w dowolnym momencie.
                            </p>
                        </div>
                        <div className={isExpand.ogolne ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['summerTime']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ summerTime: e },
                                    });
                                }}
                                isRed={isExpand['summerTime']}
                            >
                                {' '}
                                Czy zajęcia odbywają się także w wakacje?
                            </QuestionFAQ>
                            <p className={isExpand.summerTime ? 'answer' : 'dont'}>
                            Tak. W okresie wakacyjnym przygotowujemy specjalną ofertę zajęć w różnych stylach i na różnych poziomach zaawansowania. Szczegółowe informacje na temat wakacyjnych kursów tańca Summer Academy w Egurrola Dance Studio publikujemy na początku wakacji.
                            </p>
                        </div>
                        <div className="faqContent">
                            <CoursBar
                                isExpand={isExpand['kids']}
                                onSelect={(e) => {
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ kids: e },
                                    });
                                }}
                         
                                name={"PYTANIA DOTYCZĄCE KATEGORII DZIECI I JUNIORZY"}
                            >
                                
                            </CoursBar>
                        </div>
                        <div className={isExpand.kids ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['type']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ type: e },
                                    });
                                }}
                                isRed={isExpand['type']}
                            >
                                {' '}
                                Jakie zajęcia są do wyboru?
                            </QuestionFAQ>
                            <p className={isExpand.type ? 'answer' : 'dont'}>
                            Proponujemy bardzo bogatą i zróżnicowaną ofertę zajęć dla dzieci. Dla maluchów od 3. roku życia przygotowaliśmy Zabawy z tańcem i muzyką. Starszym dzieciom oferujemy natomiast zajęcia z różnych stylów, m.in. takich jak: taniec nowoczesny, hip hop, taniec jazzowy, balet, a także zajęcia z gimnastyki. Dostępność zajęć jest zależna od lokalizacji.
                            </p>
                        </div>
                        <div className={isExpand.kids ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['dressCode']}
                                setIsEcpand={(e) => {
                                    ;
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ dressCode: e },
                                    });
                                }}
                                isRed={isExpand['dressCode']}
                            >
                                {' '}
                                Jaki strój obowiązuje na zajęciach?
                            </QuestionFAQ>
                            <p className={isExpand.dressCode ? 'answer' : 'dont'}>
                            Na zajęcia najlepszy jest strój sportowy, umożliwiający swobodne poruszanie się (np. koszulka i spodenki lub legginsy) oraz wygodne buty sportowe. Na zajęciach z baletu mogą to być rajstopki i body, obuwie: baletki. Na zajęciach z tańca jazzowego – baletki lub jazzówki. Egurrola Dance Studio oferuje własną linię ubrań do tańca oraz dodatków, dostępną w sklepie Egurrola Store na stronie{' '}
                                <a>egurrolastore.com</a>.
                            </p>
                        </div>
                        <div className={isExpand.kids ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['observer']}
                                setIsEcpand={(e) => {
                            
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ observer: e },
                                    });
                                }}
                                isRed={isExpand['observer']}
                            >
                                {' '}
                                Czy rodzice mogą być obecni na zajęciach?
                            </QuestionFAQ>
                            <p className={isExpand.observer ? 'answer' : 'dont'}>
                            Z doświadczenia wiemy, że obecność rodziców rozprasza dzieci, dlatego prosimy ich o to, aby nie wchodzili na sale w czasie trwania zajęć regularnych. Rodziców wraz z dziećmi zapraszamy natomiast na lekcje otwarte, w czasie których mogą sprawdzić, jak przebiegają zajęcia. Szczegółowych informacji na temat terminów lekcji otwartych udzielają instruktorzy.
                            </p>
                        </div>
                        <div className={isExpand.kids ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['differentKids']}
                                setIsEcpand={(e) => {
                                    
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ differentKids: e },
                                    });
                                }}
                                isRed={isExpand['differentKids']}
                            >
                                {' '}
                                Czy organizujecie jakieś inne formy aktywności dla dzieci oprócz regularnych kursów tańca?
                            </QuestionFAQ>
                            <p className={isExpand.differentKids ? 'answer' : 'dont'}>
                            Tak, poza zajęciami regularnymi organizujemy także letnie i zimowe obozy taneczne, roztańczone półkolonie, bale i imprezy tematyczne dla dzieci oraz roztańczone urodziny.
                            </p>
                        </div>
                        <div className="faqContent">
                            <CoursBar
                                isExpand={isExpand['teen']}
                                onSelect={(e) => {
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ teen: e },
                                    });
                                }}
                                name={"PYTANIA DOTYCZĄCE KATEGORII MŁODZIEŻ I STUDENCI"}
                            >
                                
                            </CoursBar>
                        </div>
                        <div className={isExpand.teen ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['course']}
                                setIsEcpand={(e) => {
                             
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ course: e },
                                    });
                                }}
                                isRed={isExpand['course']}
                            >
                                {' '}
                                Jakie zajęcia są do wyboru?
                            </QuestionFAQ>
                            <p className={isExpand.course ? 'answer' : 'dont'}>
                            Oferujemy zajęcia z różnych stylów tanecznych, m.in.: hip hop, commercial, taniec jazzowy, contemporary jazz, taniec klasyczny, a także zajęcia z akrobatyki. Dostępność zajęć jest zależna od lokalizacji.
                            </p>
                        </div>
                        <div className={isExpand.teen ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['eqTeen']}
                                setIsEcpand={(e) => {
                                    
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ eqTeen: e },
                                    });
                                }}
                                isRed={isExpand['eqTeen']}
                            >
                                {' '}
                                Jaki strój obowiązuje na zajęciach?
                            </QuestionFAQ>
                            <p className={isExpand.eqTeen ? 'answer' : 'dont'}>
                            Na zajęcia najlepszy jest strój sportowy, umożliwiający swobodne poruszanie się (np. koszulka i spodenki lub legginsy) oraz wygodne buty sportowe. Na zajęcia high heels należy zabrać ze sobą buty na niewysokim, stabilnym i szerokim obcasie, np. sznurowane botki. Egurrola Dance Studio oferuje własną linię ubrań do tańca oraz dodatków, dostępną w sklepie Egurrola Store na stronie{' '}
                                <a>egurrolastore.com</a>.
                            </p>
                        </div>
                        <div className={isExpand.teen ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['dressCodeTeen']}
                                setIsEcpand={(e) => {
                                
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ dressCodeTeen: e },
                                    });
                                }}
                                isRed={isExpand['dressCodeTeen']}
                            >
                                Czy organizujecie jakieś inne formy aktywności dla młodzieży i studentów oprócz regularnych kursów tańca?
                            </QuestionFAQ>
                            <p className={isExpand.dressCodeTeen ? 'answer' : 'dont'}>
                            Tak, regularnie organizujemy warsztaty taneczne dla początkujących i profesjonalnych tancerzy oraz Egurrola Camp – letni obóz taneczny dla młodzieży powyżej 16. roku życia (szczegółowe informacje znajdują się na podstronie „Wydarzenia”).
                            </p>
                        </div>
                        <div className={isExpand.teen ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['wf']}
                                setIsEcpand={(e) => {
                                  
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ wf: e },
                                    });
                                }}
                                isRed={isExpand['wf']}
                            >
                                Czy oferujecie studentom możliwość zaliczania WF-u poprzez udział w zajęciach?
                            </QuestionFAQ>
                            <p className={isExpand.wf ? 'answer' : 'dont'}>
                            Tak. Aby dowiedzieć się więcej na temat możliwości zaliczenia WF-u, prosimy o kontakt z recepcją wybranej szkoły Egurrola Dance Studio.
                            </p>
                        </div>
                        <div className="faqContent">
                            <CoursBar
                                isExpand={isExpand['adults']}
                                onSelect={(e) => {
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ adults: e },
                                    });
                                }}
                                name={"PYTANIA DOTYCZĄCE KATEGORII DOROŚLI"}
                            >
                                
                            </CoursBar>
                        </div>
                        <div className={isExpand.adults ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['courseAdults']}
                                setIsEcpand={(e) => {
                               
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ courseAdults: e },
                                    });
                                }}
                                isRed={isExpand['courseAdults']}
                            >
                                Jakie zajęcia są do wyboru?
                            </QuestionFAQ>
                            <p className={isExpand.courseAdults ? 'answer' : 'dont'}>
                            Paniom oferujemy zajęcia w różnych stylach tanecznych, m.in. takich jak: high heels, commercial ladies, latino solo, salsa solo, a mamom – dance moms. Dla par przygotowaliśmy regularne kursy tańca towarzyskiego oraz sekcję tańca towarzyskiego, a dla osób niemających pary – kursy tańca towarzyskiego dla singli. Dostępność zajęć jest zależna od lokalizacji.
                            </p>
                        </div>
                        <div className={isExpand.adults ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['eqAdults']}
                                setIsEcpand={(e) => {
                                
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ eqAdults: e },
                                    });
                                }}
                                isRed={isExpand['eqAdults']}
                            >
                                Jaki strój obowiązuje na zajęciach?
                            </QuestionFAQ>
                            <p className={isExpand.eqAdults ? 'answer' : 'dont'}>
                            Na zajęcia najlepszy jest strój sportowy, umożliwiający swobodne poruszanie się (np. koszulka i spodenki lub leginsy) oraz wygodne buty sportowe. Na zajęcia high heels należy zabrać ze sobą buty na niewysokim, stabilnym i szerokim obcasie, np. sznurowane botki. Egurrola Dance Studio oferuje własną linię ubrań do tańca oraz dodatków, dostępną w sklepie Egurrola Store na stronie 
                                egurrolastore.com.
                            </p>
                        </div>

                        <div className={isExpand.adults ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['different']}
                                setIsEcpand={(e) => {
                          
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ different: e },
                                    });
                                }}
                                isRed={isExpand['different']}
                            >
                                {' '}
                                Czy organizujecie jakieś inne formy aktywności oprócz regularnych kursów tańca?
                            </QuestionFAQ>
                            <p className={isExpand.different ? 'answer' : 'dont'}>
                            Tak. Regularnie organizujemy wieczorki taneczne oraz sezonowe wyjazdy z tańcem dla dorosłych.
                            </p>
                        </div>
                        <div className={isExpand.adults ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['singiel']}
                                setIsEcpand={(e) => {
                           
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ singiel: e },
                                    });
                                }}
                                isRed={isExpand['singiel']}
                            >
                                {' '}
                                Nie mam partnera do tańca – czy mimo tego mogę zapisać się na zajęcia tańca towarzyskiego?
                            </QuestionFAQ>
                            <p className={isExpand.singiel ? 'answer' : 'dont'}>
                            Oczywiście, że tak! Brak partnera do tańca w Egurrola Dance Studio nie jest żadną przeszkodą – organizujemy specjalne kursy tańca dla singli.
                            </p>
                        </div>
                        <div className={isExpand.adults ? 'faqQuestion_content' : 'dont'}>
                            <QuestionFAQ
                                isExpand={isExpand['engaged']}
                                setIsEcpand={(e) => {
                                
                                    setIsEcpand({
                                        ...isExpand,
                                        ...{ engaged: e },
                                    });
                                }}
                                isRed={isExpand['engaged']}
                            >
                                {' '}
                                Czy organizujecie kursy tańca dla narzeczonych?
                            </QuestionFAQ>
                            <p className={isExpand.engaged ? 'answer' : 'dont'}>Tak, specjalnie dla nich przygotowaliśmy kursy regularne, weekendowe kursy intensywne a także lekcje indywidualne.</p>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default FAQ;
